import { isUploadedFile } from '@prezly/uploads';
import { Element } from "../Element.mjs";
export var AttachmentNode;

(function (AttachmentNode) {
  AttachmentNode.TYPE = 'attachment';

  function isAttachmentNode(value) {
    return Element.isElement(value, AttachmentNode.TYPE);
  }

  AttachmentNode.isAttachmentNode = isAttachmentNode;

  function validateAttachmentNode(value) {
    var isValid = isAttachmentNode(value) && typeof value.description === 'string' && isUploadedFile(value.file);
    return isValid ? value : null;
  }

  AttachmentNode.validateAttachmentNode = validateAttachmentNode;
})(AttachmentNode || (AttachmentNode = {}));